/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * An enumeration.
 */
export enum SampleRequestEstimatedAnnualUsage {
  LESS_THAN_50KG = "less_than_50kg",
  BETWEEN_50_AND_500KG = "between_50_and_500kg",
  BETWEEN_501_AND_1000KG = "between_501_and_1000kg",
  BETWEEN_1_AND_20_TONS = "between_1_and_20_tons",
  BETWEEN_20_AND_100_TONS = "between_20_and_100_tons",
  MORE_THAN_100_TONS = "more_than_100_tons",
}
